module.exports = __webpack_public_path__ + "img/sos-type-silver.1d839a72.png";